<section class="vc-admin-roles-list">
  <app-admin-list-toolbar
    titleKey="ADMIN.ROLES.TITLE"
    descriptionKey="ADMIN.IA.ROLES.DESCRIPTION"
    [showSearch]="true"
    searchPlaceholderKey="COMMON.SEARCH"
    [searchValue]="searchValue"
    (searchValueChange)="onSearch($event)"
  >
    <button
      toolbar-actions
      pButton
      type="button"
      icon="fas fa-plus"
      class="p-button-sm"
      [label]="'COMMON.ADD' | translate"
      (click)="router.navigate(['/administration', customer_route_param, 'roles', 'new'])"
    ></button>
  </app-admin-list-toolbar>

  @if (filteredRoles.length === 0) {
    <app-admin-state-panel
      mode="empty"
      titleKey="ADMIN.ROLES.EMPTY.TITLE"
      descriptionKey="ADMIN.ROLES.EMPTY.DESCRIPTION"
    ></app-admin-state-panel>
  } @else {
    <p-table
      [value]="filteredRoles"
      styleClass="Table"
      responsiveLayout="scroll"
      [autoLayout]="true"
      [paginator]="true"
      [rows]="20"
      [rowsPerPageOptions]="[20, 40, 100]"
    >
      <ng-template pTemplate="header">
        <tr>
          <th>{{ 'COMMON.ROLE_NAME' | translate }}</th>
          <th>{{ 'COMMON.ACTIONS' | translate }}</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-role>
        <tr>
          <td>{{ role.name }}</td>
          <td>
            <app-admin-table-actions
              [manageRouterLink]="[
                '/administration',
                customer_route_param,
                'roles',
                role.id
              ]"
              [showDelete]="!isLockedAdminRole(role)"
              (delete)="confirmDelete(role)"
            ></app-admin-table-actions>
          </td>
        </tr>
      </ng-template>
    </p-table>
  }
</section>
